import React from 'react';
import { AuthLayout } from '../../../Components/PageLayouts/AuthLayout';
import { SignUpFormModule } from '../../../Modules/@Forms/SignUpFormModule';

interface Props {}

const SignUpPage: React.FC<Props> = () => {
  return (
    <AuthLayout>
      <SignUpFormModule />
    </AuthLayout>
  );
};

export default SignUpPage;
